import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, MenuProps, Tooltip } from 'antd';
import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './ModeDropdown.module.scss';
import { faBolt, faBrain } from '@fortawesome/free-solid-svg-icons';
import { getTheme } from 'helpers/getTheme';
import { useAppDispatch, useAppSelector } from 'store/hook';
import api from 'api';
import { setEditorTokenDetails } from 'store/slices/aiFunctionsDataSlice';

type ModeDropdownProps = { };

const ModeDropdown = ({ }: ModeDropdownProps) => {
  const { editorTokenDetails, currentEditorToken } = useAppSelector((state) => state.aiFunctions);
  const { messageApi } = useAppSelector((state) => state.windowState);

  const [openTipAI, setOpenTipAI] = React.useState(false);
  const [openSelectMode, setOpenSelectMode] = React.useState(false);
  const [updatingMode, setUpdateingMode] = React.useState(false);

  const dispatch = useAppDispatch();
  const chooseMode = () => setOpenTipAI(false);
  
  const { t } = useTranslation();
  const itemClick = async (e: any) => {
    try {
      setUpdateingMode(true);
      await api.updateEditingToken(currentEditorToken!, {...editorTokenDetails!, ai_model_type: e.key});
      dispatch(setEditorTokenDetails({...editorTokenDetails!, ai_model_type: e.key}));
    } catch (e) {
      messageApi?.error(t('Chats.selectAI.changeError'));
    } finally {
      setUpdateingMode(false);
    }
  };

  const changeMode = async (e: any) => {    
    e.key !== editorTokenDetails?.ai_model_type && itemClick(e);
  };

  const AIModes: MenuProps['items'] = [
    {
      label: (
        <span className={classes.spanItem}>
          <FontAwesomeIcon icon={faBolt}/>{t('Chats.selectAI.fast')}
        </span>
      ),
      onClick: changeMode,
      className: classes.itemAI,
      key: 'flash',
    },
    { type: 'divider', className: classes.divider },
    {
      label: (
        <span className={classes.spanItem}>
          <FontAwesomeIcon icon={faBrain}/>{t('Chats.selectAI.deep')}
        </span>
      ),
      className: classes.itemAI,
      onClick: itemClick,
      key: 'deep',
    },
  ];
  
  return (
    <Dropdown
      menu={{ items: AIModes }}
      classNames={{ root: getTheme() }}
      open={openSelectMode}
      trigger={['click']}
      align={{ offset: [0, -2] }}
      arrow={false}
      onOpenChange={setOpenSelectMode}
        >
      <Tooltip
        open={!openSelectMode && openTipAI}
        title={t('Chats.selectAI.tip')}
        mouseEnterDelay={.5}
        onOpenChange={setOpenTipAI}
      >
        <Button
          type='text'
          onClick={chooseMode}
          size='small'
          className={cn(classes.modeIcon)}
          loading={updatingMode}
          icon={
            <FontAwesomeIcon icon={editorTokenDetails?.ai_model_type === 'flash' ? faBolt : faBrain}/>
          }
        />
      </Tooltip>
    </Dropdown>
  );
}

export default ModeDropdown;
